import React, { createContext, useContext } from 'react';

export type NavKey = 'dashboard' | 'floor' | 'reservations' | 'orders' | 'menu' | 'support' | 'guest' | 'settings';

interface NavValue {
  activeKey: NavKey;
  navigate: (key: NavKey) => void;
}

const NavContext = createContext<NavValue>({ activeKey: 'dashboard', navigate: () => {} });

export const NavProvider = NavContext.Provider;

/** Section navigation for screens (replaces react-router's useNavigate). navigate('orders') etc. */
export function useNav(): NavValue {
  return useContext(NavContext);
}
